export default class GiftCardRecipientForm extends Core.Component {
  constructor(el, context) {
    super(el, context);
    this.inputs = this.el.querySelectorAll('[data-input]');
    this.email = this.el.querySelector('[data-input-email]');
    this.checkbox = this.el.querySelector('[data-input-checkbox]');
    this.notification = this.el.querySelector('.notification');

    this.events.register(this.checkbox, 'change', () => {
      if (this.checkbox.checked) {
        this._open();
      } else {
        this._close();
      }
    });
  }

  _open() {
    this.el.classList.add('recipient-form--open');
    this.email.setAttribute('required', '');
  }

  _close() {
    this.el.classList.remove('recipient-form--open', 'recipient-form--errors');
    this.email.removeAttribute('required');

    if (this.notification) {
      this.notification.hidden = true;
    }

    this.inputs.forEach(input => {
      input.value = '';
    });
  }
}
